import { useState } from 'react';
import { Button } from 'react-bootstrap';

import ImageQuestionContentModal from './ImageQuestionContentModal';
import Translated from './Translated';

const ImageQuestionModalLink = ({ questionId, refetch }) => {
  const [showModal, setShowModal] = useState(false);
  const editMode = Boolean(questionId);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <Button onClick={openModal}><Translated translationKey={editMode ? 'edit' : 'create_image'} /></Button>
      {showModal && (
        <ImageQuestionContentModal
          questionId={questionId}
          onClose={closeModal}
          onCloseAfterUpdate={refetch}
        />
      )}
    </>
  );
};

export default ImageQuestionModalLink;